import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './app/App.js'
import './index.css'

// Dev-only: expose router store on window for E2E / Playwright navigation.
if (import.meta.env.DEV) {
  import('./shared/router-store.js').then(({ useRouter }) => {
    ;(window as unknown as Record<string, unknown>).__router = useRouter
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
